import React, { SyntheticEvent } from 'react'
import { connect } from 'react-redux'
import { AppState } from '@chegg-wt/core/state'
import { isProSelector } from '@chegg-wt/core/state/user/selectors'
import AppLink from '@chegg-wt/core/components/AppLink'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { hasExpired } from '@chegg-wt/core/utils/projects'
import { GATED_BIBLIOGRAPHY_ON_EXPIRATION_MODAL } from '@chegg-wt/core/state/modals/constants'
import { openModal } from '@chegg-wt/core/state/modals/actions'
import { GatedBibliographyOnExpirationModalData } from '@chegg-wt/core/state/bibliography/types'
import { format, parseISO } from 'date-fns'
import { HiddenLabel } from '@chegg-wt/core/components/HiddenLabel'
import { Config } from '@chegg-wt/core/config'
import * as Styled from './styled'
import { ProjectListItemLinkProps } from './types'
import { PROJECT_LIST_ITEM_LINK_LINK, PROJECT_LIST_ITEM_LINK_CONTAINER } from './testIds'

export const ProjectListItemLink: React.FunctionComponent<ProjectListItemLinkProps> = ({
  id,
  name,
  createdAt,
  style,
  isPro,
  openModal,
}) => {
  const { toBibliography, toCitationList } = useRoutesContext()
  const { hasPremiumCitations } = Config
  const route =
    hasPremiumCitations && isPro
      ? toCitationList({ projectId: id })
      : toBibliography({ style, projectId: id })
  const titleElement = (
    <Styled.Title data-test={PROJECT_LIST_ITEM_LINK_LINK}>
      <Styled.ProjectTitleText title={name}>{name}</Styled.ProjectTitleText>
      <HiddenLabel>
        Created:{' '}
        {createdAt ? format(parseISO(createdAt), 'MM/dd/yyyy HH:mm:ss') : 'Invalid Date'}
      </HiddenLabel>
    </Styled.Title>
  )
  const isProjectExpired = !isPro && !!createdAt && hasExpired(createdAt)
  const handleClick = (event: SyntheticEvent) => {
    event.preventDefault()
    openModal({
      name: GATED_BIBLIOGRAPHY_ON_EXPIRATION_MODAL,
      data: {
        isDismissible: true,
        shouldContinueToFolders: false,
      } as GatedBibliographyOnExpirationModalData,
    })
  }

  return (
    <>
      {isProjectExpired ? (
        <Styled.TitleContainer
          onClick={handleClick}
          data-test={PROJECT_LIST_ITEM_LINK_CONTAINER}
        >
          {titleElement}
        </Styled.TitleContainer>
      ) : (
        <AppLink route={route}>{titleElement}</AppLink>
      )}
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  isPro: isProSelector(state),
})

const mapDispatchToProps = {
  openModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectListItemLink)
